<template>
  <div>
    <div class="main" v-show="star">
      <div style="font-weight: bold;font-size: 24px;">MBTI性格类型测试问卷</div>
      <div class="flex">
        <div class="one" v-for="(item,index) in data">
          <div class="one_title">
            {{index+1}}.{{item.question}}
          </div>
          <div class="options">A.{{item.option_a}}</div>
          <el-slider v-model="item.score" :marks="marks" show-stops :max="5" :min="0" @change='changeA(item)'>
          </el-slider>
          <div class="options1">B.{{item.option_b}}</div>
          <el-slider v-model="item.score1" :marks="marks" show-stops :max="5" :min="0" @change='changeB(item)'>
          </el-slider>
        </div>
      </div>
      <el-button type="primary" style="width: 200px;margin-top: 80px;" @click="submit">提交</el-button>
    </div>
    <div v-show="!star">
      <div class="banner">
        <div class="img_title">
          <span>MBTI性格类型测试</span>
        </div>
        <div class="img_little_title">
          <span>注意事项：</span>
        </div>
        <div class="img_text">
          <span>
            <p>1．请在心态平和及时间充足的情况下才开始答题。</p>
            <p>2．每道题目均有两个答案：A和B。请仔细阅读题目，按照与你性格相符的程度分别给A 和B赋予一个分数，并使一组中的两个分数之和为5。最后，请在问卷后的答题纸上相应的方 格内填上相应的分数。</p>
            <p>3．请注意，题目的答案无对错之分，你不需要考虑哪个答案“应该”更好，而且不要 在任何问题上思考太久，而是应该凭你心里的第一反应做出选择。</p>
            <p>4．如果你觉得在不同的情境里，两个答案或许都能反映你的倾向，请选择一个对于你 的行为方式来说最自然、最顺畅和最从容的答案。</p>
            <p>例子：“你参与社交聚会时”</p>
            <p>A．总是能认识新朋友。（4）</p>
            <p>B．只跟几个亲密挚友呆在一起。（1）</p>
            <p>很明显，你参与社交聚会时有时能认识新朋友，有时又会只跟几个亲密挚友呆在一起， 在以上的例子中，我们给总是能认识新朋友打了4分，而给只跟几个亲密挚友呆在一起打了1
              分。当然，在你看来，也可能是3+2或者5+0，也可以是其他的组合。</p>
          </span>
        </div>
        <div class="img_button">
          <span><a @click="star = true">开始测试</a> </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        marks: {
          0: '0',
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        },
        star: false,
        data: [],
        EI: 0,
        SN: 0,
        TF: 0,
        JP: 0
      }
    },
    created() {
      this.$http.testMbtiQuestion().then(res => {
        this.data = res.data.list
        this.data.forEach(item => {
          item.score1 = 0
          item.score2 = 0
        })
      })
    },
    methods: {
      submit() {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].type == 'EI') {
            this.EI = this.EI + Number(this.data[i].score2)
          }
          if (this.data[i].type == 'SN') {
            this.SN = this.SN + Number(this.data[i].score2)
          }
          if (this.data[i].type == 'TF') {
            this.TF = this.TF + Number(this.data[i].score2)
          }
          if (this.data[i].type == 'JP') {
            this.JP = this.JP + Number(this.data[i].score2)
          }
        }
        let result = [this.EI, this.SN, this.TF, this.JP]
        this.$router.push(`testResult?result=${result}`)
        this.$http.testMbtiResult({
          result: result
        }).then(res => {
          console.log(res)
        })
      },
      changeA(item) {
        item.score1 = 5 - item.score
        item.score2 = item.score - item.score1
        console.log(item.score2)
        this.$forceUpdate()
      },
      changeB(item) {
        item.score = 5 - item.score1
        item.score2 = item.score - item.score1
        console.log(item.score2)
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    width: 1280px;
    margin: 20px auto;
    justify-content: space-around;
  }

  .one {
    width: 500px;
    margin: 20px 0;
    text-align: left;

    .one_title {
      font-weight: bold;
    }

    .options {
      margin: 15px 0 15px 0;
    }

    .options1 {
      margin: 25px 0 10px 0;
    }
  }

  .flex {
    justify-content: space-between;
  }

  .banner {
    width: 1280px;
    margin: 20px auto;
    position: relative;
    margin-bottom: 56px
  }

  .bg {
    /*background: rgba(35,109,184,0.02);*/
    min-height: 400px;
    margin-left: 18%;
    margin-right: 18%;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .img_title {
    margin: 40px 0;
    // position: absolute;
    // left: 50%;
    // top: 6%;
    // margin-left: -130px;
  }

  .img_title span {
    font-size: 26px;
    color: #236DB8;

  }

  .img_little_title {
    text-align: left;
    margin-bottom: 20px;
    // position: absolute;
    // left: 54%;
    // top: 14%;
    // margin-left: -600px;
  }

  .img_little_title span {
    font-size: 20px;
    color: #236DB8;
    font-weight: bold;
  }

  .img_text {
    text-align: left;
    // position: absolute;
    // left: 56%;
    // top: 25%;
    // margin-left: -600px;
  }

  .img_text span {
    font-family: monospace;
    font-size: 15px;
    color: #333333;
    line-height: 25px;
  }

  .img_text span p {
    margin: -6px 0 8.5px;
  }

  .img_button {
    // position: absolute;
    width: 120px;
    height: 44px;
    line-height: 44px;
    border: 1px solid #236DB8;
    border-radius: 5px;
    text-align: center;
    margin: 0 auto;
    // left: 50%;
    // top: 81%;
    // margin-left: -60px;
  }

  .img_button span a {
    cursor: pointer;
    font-size: 20px;
    color: #236DB8;
    text-decoration: none;
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .padding-top-20 {
    padding-top: 20px;
  }

  .type {
    color: #236DB8;
    font-size: 18px;
    font-weight: 600;
  }

  .feature {
    padding-left: 30px;
    font-size: 16px;
    padding-top: 16px;
    font-weight: bolder;
  }

  .font-size-16 {
    font-size: 16px;
  }

  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/test/mbti.vue